import get from 'lodash.get';
import getPage from './page';

const getUsedCustomColors = (rootState, pageId) => {
  const targetPage = getPage(rootState, pageId);

  return get(targetPage, 'usedCustomColors', []);
};

export default getUsedCustomColors;
